// regEx.js
export const regEx = {
    specialPlaneL: /0\d{2,3}-\d{7,8}/, // 座机
    mobile: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, // 手机
    qq: /^[1-9][0-9]{4,14}$/, // qq
    email: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    password: /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,18}$/
  }
  